import { Directive, ElementRef, inject, OnInit, input, OnDestroy } from '@angular/core';
import { ItcTooltipDirective } from './itc-tooltip.directive';
@Directive({
    selector: '[truncateText]',
    standalone: true,
    hostDirectives: [ItcTooltipDirective],
})
export class TruncateTextDirective implements OnInit, OnDestroy {
    private el = inject(ElementRef);

    readonly truncateWidth = input<string>('100%');
    readonly truncateMaxWidth = input<string>('100%');
    readonly truncateWithIcon = input(undefined);
    readonly truncateLines = input(1);
    readonly ttPosition = input<
        | 'left'
        | 'top-left'
        | 'top'
        | 'top-right'
        | 'right'
        | 'bottom-right'
        | 'bottom'
        | 'bottom-left'
    >('bottom-left');

    readonly pollElement = input(false);
    readonly ellipseTruncatedOnly = input(false);
    readonly LINE_HEIGHT_PX = 22;
    private tooltipDirective = inject(ItcTooltipDirective);
    private fullText = '';
    private checkWidthInterval: ReturnType<typeof setInterval>;
    ngOnInit(): void {
        setTimeout(() => {
            this.fullText = this.el.nativeElement.innerText;
            this.el.nativeElement.style.width = this.truncateWidth();
            this.el.nativeElement.style.maxWidth = this.truncateMaxWidth();
            this.el.nativeElement.style.overflow = 'hidden';
            if (!this.ellipseTruncatedOnly()) {
                this.el.nativeElement.style.textOverflow = 'ellipsis';
            }
            this.el.nativeElement.style.whiteSpace = 'nowrap';

            if (this.truncateLines() > 1) {
                this.el.nativeElement.style.whiteSpace = 'normal';
                this.el.nativeElement.style.display = '-webkit-box';
                this.el.nativeElement.style.wordBreak = 'break-word';
                this.el.nativeElement.style.webkitLineClamp = this.truncateLines() + '';
                this.el.nativeElement.style.webkitBoxOrient = 'vertical';
            }
            this.checkWidthInterval = setInterval(() => {
                this.checkWidth();
            }, 10);
        }, 1);
    }

    checkWidth(): void {
        let br = this.el.nativeElement.getBoundingClientRect();
        const truncateLines = this.truncateLines();
        if (
            this.pollElement() &&
            ((truncateLines === 1 && br.width === 0) || (truncateLines > 1 && br.height === 0))
        ) {
            return;
        }

        if (
            (truncateLines === 1 &&
                this.el.nativeElement.scrollWidth > this.el.nativeElement.clientWidth) ||
            (truncateLines > 1 &&
                this.el.nativeElement.scrollHeight !== 0 &&
                this.el.nativeElement.scrollHeight > this.LINE_HEIGHT_PX * truncateLines &&
                this.el.nativeElement.scrollHeight >= this.el.nativeElement.clientHeight)
        ) {
            this.tooltipDirective.tooltipText = this.fullText;
            this.tooltipDirective.ttPosition = this.ttPosition();

            if (this.ellipseTruncatedOnly()) {
                this.el.nativeElement.style.textOverflow = 'ellipsis';
            }

            if (typeof this.truncateWithIcon() !== 'undefined') {
                this.el.nativeElement.classList.add('truncatedWithIcon-' + truncateLines);
            }
        }
        clearInterval(this.checkWidthInterval);
    }

    ngOnDestroy(): void {
        clearInterval(this.checkWidthInterval);
        this.checkWidthInterval = null;
    }
}
